import React from "react";
import PropTypes from "prop-types";

import FormInput from "core/FormInput";
import FormInputLayout from "./FormInputLayout";

const SavedCardForm = ({ response }) => {
    const {
        last4,
        expMonth,
        expYear,
        name,
        addressZip,
        receiptInfo
    } = response;

    const cardNumber = `•••• •••• •••• ${last4}`;
    const cvc = "•••";
    const expirationMonth = expMonth.length < 2 ? `0${expMonth}` : expMonth;
    const expiration = `${expirationMonth}/${expYear.slice(-2)}`;

    const disabled = true;

    return (
        <FormInputLayout
            receiptInfo={receiptInfo}
            cardNumberField={
                <FormInput
                    isDisabled={disabled}
                    value={cardNumber}
                    placeholderText="Credit card number"
                    labelText="Credit card number"
                />
            }
            mmyyField={
                <FormInput
                    isDisabled={disabled}
                    value={expiration}
                    placeholderText="MM/YY"
                    labelText="MM/YY"
                />
            }
            cvcField={
                <FormInput
                    isDisabled={disabled}
                    value={cvc}
                    placeholderText="CVC"
                    labelText="CVC"
                />
            }
            nameField={
                <FormInput
                    isDisabled={disabled}
                    value={name}
                    placeholderText="Name on card"
                    labelText="Name on card"
                />
            }
            postalField={
                <FormInput
                    isDisabled={disabled}
                    value={addressZip}
                    placeholderText="Postal code"
                    labelText="Postal code"
                />
            }
        />
    );
};

SavedCardForm.propTypes = {
    response: PropTypes.object.isRequired
};

export default SavedCardForm;
